import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';

import type { EmailInlineAttachmentPayload } from '../../shared/components/send-email-modal/models/send-email-data.model';

/** Request shape for POST send email API (same shape as EmailPayload from shared). */
export interface SendEmailRequest {
  readonly to: string[];
  readonly cc?: string[];
  readonly bcc?: string[];
  readonly subject: string;
  readonly includeAnalytics: boolean;
  readonly deIdentifyPatientData: boolean;
  readonly templateKey?: string;
  readonly model?: Record<string, unknown>;
  readonly chartImages?: Record<string, string>;
  readonly inlineAttachments?: readonly EmailInlineAttachmentPayload[];
  readonly RequiredEmailResponse?: boolean;
  readonly IncidentId?: number;
}

export interface SendEmailResponse {
  readonly success: boolean;
}

export interface EmailSendClient {
  send(payload: SendEmailRequest): Observable<SendEmailResponse>;
}

export const EMAIL_SEND_CLIENT = new InjectionToken<EmailSendClient>('EMAIL_SEND_CLIENT');
